module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "inter"
  }, [_c('div', {
    staticClass: "flex flex-row items-center responsive-title pl2 pr2 pb2",
    on: {
      "click": _vm.goBack
    }
  }, [_c('arrow-back1'), _vm._v(" "), _c('h3', {
    staticClass: "ml2 f4 cera-round-pro"
  }, [_vm._v(_vm._s(_vm.$t('referralssettings.referralsettingsheader', {
    referralsettingsheader: 'Referrals'
  })))])], 1), _vm._v(" "), (!_vm.showEditReferralCodeModal) ? _c('div', {
    staticClass: "mv2 ph3 flex flex-column justify-center items-start height-dv"
  }, [_c('div', {
    staticClass: "flex flex-column"
  }, [_c('div', {
    staticClass: "mt1 elementLeft"
  }, [_vm._v(_vm._s(_vm.$t('referralssettings.mycode', {
    mycode: 'My Code'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row justify-between w-100"
  }, [_c('span', {
    staticClass: "data fw5"
  }, [_vm._v(_vm._s(_vm.user.referral_code))]), _vm._v(" "), _c('span', {
    staticClass: "color-theme data pointer",
    on: {
      "click": function($event) {
        _vm.showEditReferralCodeModal = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.edit', {
    edit: 'Edit'
  })))])])]) : _vm._e(), _vm._v(" "), (_vm.showEditReferralCodeModal) ? _c('div', {
    staticClass: "row-edit mv2 desktop modal-opened-row"
  }, [_c('div', {
    staticClass: "elementLeft modal-opened-row-text"
  }, [_vm._v(_vm._s(_vm.$t('referralssettings.editreferral', {
    editreferral: 'Edit your referral code'
  })))]), _vm._v(" "), _c('div', {
    staticClass: "modal w-75"
  }, [_c('form', {
    staticClass: "flex-column",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mt3 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "pass"
    }
  }, [_vm._v(_vm._s(_vm.$t('referralssettings.newcode', {
    newcode: 'NEW REFERRAL CODE'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referralCode),
      expression: "referralCode"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "pass"
    },
    domProps: {
      "value": (_vm.referralCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.referralCode = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex flex-row justify-between justify-end-ns",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "mr3 flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    staticClass: "modal-button inter fw6 cancel",
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showEditReferralCodeModal = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.cancel', {
    cancel: 'Cancel'
  })) + "\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    staticClass: "modal-button inter fw6 save",
    attrs: {
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateReferralCode.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.save', {
    save: 'Save'
  })) + "\n          ")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.showEditReferralCodeModal) ? _c('div', {
    staticClass: "modal flex-row mobile w-75"
  }, [_c('form', {
    staticClass: "flex-column mh3 mt4"
  }, [_c('div', {
    staticClass: "mb3"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('referralssettings.editreferral2', {
    editreferral2: 'Edit your referral code'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "mt3 mb2 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "mobile-code"
    }
  }, [_vm._v(_vm._s(_vm.$t('referralssettings.newcode', {
    newcode: 'NEW REFERRAL CODE'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referralCode),
      expression: "referralCode"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "mobile-code",
      "type": "text"
    },
    domProps: {
      "value": (_vm.referralCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.referralCode = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex mh4 flex-row pb3 justify-between"
  }, [_c('div', {
    staticClass: "w-48"
  }, [_c('ak-button', {
    staticClass: "modal-button inter",
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.cancel', {
    cancel: 'Cancel'
  })))])], 1), _vm._v(" "), _c('div', {
    staticClass: "w-48"
  }, [_c('ak-button', {
    staticClass: "modal-button inter",
    attrs: {
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateReferralCode.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('edit.save', {
    save: 'Save'
  })) + "\n        ")])], 1)])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "line mh3"
  }), _vm._v(" "), _c('div', {
    staticClass: "mv2 ph3 flex flex-column justify-center items-start height-dv"
  }, [_c('div', {
    staticClass: "flex flex-column"
  }, [_c('div', {
    staticClass: "mt1 elementLeft"
  }, [_vm._v(_vm._s(_vm.$t('referralssettings.deductible', {
    deductible: 'Total Deductible Credit Balance'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row"
  }, [_c('div', {
    staticClass: "data"
  }, [_vm._v("$" + _vm._s(this.$store.state.user.total_deductible_credit.toFixed(2)))])])]), _vm._v(" "), _c('div', {
    staticClass: "pl3 desktop pr3 mt3"
  }, [_c('router-link', {
    staticClass: "no-underline",
    attrs: {
      "to": ""
    }
  }, [_c('ak-button', {
    staticClass: "inter share-btn fw6",
    attrs: {
      "disabled": !this.user.is_activated,
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.shareResetState.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('referralssettings.share', {
    share: 'Share Referral Code'
  })) + "\n      ")])], 1)], 1), _vm._v(" "), (_vm.showShareReferralCodeModal) ? _c('ak-modal', {
    attrs: {
      "cera-title": "",
      "no-hr": "",
      "small": "",
      "title": _vm.$t('referralssettings.title', {
        title: 'Share AKKO with your friends and family'
      })
    },
    on: {
      "close": _vm.resetState
    }
  }, [_c('div', {
    staticClass: "mh3 btn-container flex",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "flex flex-grow btn-height mb2 mr2"
  }, [_c('ak-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.referralCode),
      expression: "referralCode",
      arg: "copy"
    }],
    staticClass: "inter btn-height flex flex-grow copy-btn",
    attrs: {
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.copyReferralCode.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "copy-btn-code cera-round-pro"
  }, [_vm._v(_vm._s(_vm.referralCode))]), _vm._v(" "), _c('span', {
    staticClass: "flex-grow"
  }), _vm._v(" "), _c('span', {
    staticClass: "copy-btn-text f7"
  }, [_vm._v(_vm._s(_vm.$t('referralssettings.copycode', {
    copycode: 'Copy Code'
  })))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center logo-height mb2"
  }, [_c('a', {
    staticClass: "flex logo-height pointer email-logo",
    attrs: {
      "href": _vm.emailPath
    }
  }, [_c('img', {
    attrs: {
      "alt": "email",
      "src": "/static/appicons/Email.svg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center logo-height mb2"
  }, [_c('ShareNetwork', {
    attrs: {
      "description": ("I just signed up with AKKO to protect my phone and all electronics for only $15/mo. Check it out! " + _vm.shareBody),
      "quote": ("I just signed up with AKKO to protect my phone and all electronics for only $15/mo. Check it out! " + _vm.shareBody),
      "network": "facebook",
      "title": "I just signed up with AKKO to protect my phone and all electronics for only $15/mo. Check it out!",
      "url": "https://getAKKO.com"
    }
  }, [_c('div', {
    staticClass: "facebook-logo"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center logo-height mb2"
  }, [_c('ShareNetwork', {
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "description": _vm.shareBody,
      "quote": _vm.shareBody,
      "title": ("I just signed up with AKKO to protect my phone and all electronics for only $15/mo. Check it out! " + _vm.shareBody),
      "network": "twitter",
      "url": "https://getAKKO.com"
    }
  }, [_c('img', {
    staticClass: "twitter-logo",
    attrs: {
      "alt": "Twitter",
      "src": "/static/social/twitter_sky_blue.png"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex ph4 pb4 flex-column lh-copy f6 silver",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(_vm.copyPressed) ? _c('div', {
    staticClass: "flex w-100 f5 justify-start mb4",
    staticStyle: {
      "height": "10px",
      "color": "black"
    }
  }, [_c('div', [_vm._v("\n          " + _vm._s(_vm.$t('referralssettings.copied', {
    copied: 'Copied!'
  })) + "\n        ")])]) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.$t('referralssettings.alert', {
    alert: "Anyone who uses your code will get their 1st month FREE and you'll get a $20 credit towards your deductibles on any future claims you have! You get a $20 credit per referral, with no limit on how much credit you can stack up."
  })) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mar-horizontal mobile-flex btn-container flex-wrap flex share-container justify-between"
  }, [_c('div', {
    staticClass: "flex btn-height mb2"
  }, [_c('ak-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.referralCode),
      expression: "referralCode",
      arg: "copy"
    }],
    staticClass: "inter btn-height",
    attrs: {
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.copyReferralCode.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('referralssettings.copycode2', {
    copycode2: 'Copy Referral Code'
  })) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center flex-row"
  }, [_c('div', {
    staticClass: "flex silver mb2 mr2"
  }, [_vm._v(_vm._s(_vm.$t('referralssettings.share2', {
    share2: 'Or Share Code'
  })))]), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "flex items-center logo-height mb2"
  }, [_c('ShareNetwork', {
    staticClass: "flex logo-height pointer sms-logo",
    attrs: {
      "description": _vm.shareBody,
      "network": "sms",
      "title": "Message (SMS)",
      "url": "https://getAKKO.com"
    }
  }, [_c('img', {
    attrs: {
      "alt": "SMS",
      "src": "/static/appicons/Message.svg"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex items-center logo-height mb2"
  }, [_c('a', {
    staticClass: "flex logo-height pointer email-logo",
    attrs: {
      "href": _vm.emailPath
    }
  }, [_c('img', {
    attrs: {
      "alt": "email",
      "src": "/static/appicons/Email.svg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center logo-height mb2"
  }, [_c('ShareNetwork', {
    attrs: {
      "description": ("I just signed up with AKKO to protect my phone and all electronics for only $15/mo. Check it out! " + _vm.shareBody),
      "quote": ("I just signed up with AKKO to protect my phone and all electronics for only $15/mo. Check it out! " + _vm.shareBody),
      "network": "facebook",
      "title": "I just signed up with AKKO to protect my phone and all electronics for only $15/mo. Check it out!",
      "url": "https://getAKKO.com"
    }
  }, [_c('div', {
    staticClass: "facebook-logo"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center logo-height mb2"
  }, [_c('ShareNetwork', {
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "description": _vm.shareBody,
      "quote": _vm.shareBody,
      "title": ("I just signed up with AKKO to protect my phone and all electronics for only $15/mo. Check it out! " + _vm.shareBody),
      "network": "twitter",
      "url": "https://getAKKO.com"
    }
  }, [_c('img', {
    staticClass: "twitter-logo",
    attrs: {
      "alt": "Twitter",
      "src": "/static/social/twitter_sky_blue.png"
    }
  })])], 1)]), _vm._v(" "), (_vm.copyPressed) ? _c('div', {
    staticClass: "flex w-100 justify-center mb3",
    staticStyle: {
      "height": "10px"
    }
  }, [_c('div', [_vm._v("\n        " + _vm._s(_vm.$t('referralssettings.copied', {
    copied: 'Copied!'
  })) + "\n      ")])]) : _vm._e()])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-68bba9bd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68bba9bd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account-settings/screens/referrals/ReferralsComponent.vue
// module id = 1299
// module chunks = 0